import React from "react";

import type {
    ServerCmsModelsSnippetsProductProductDocument as ProductDocumentProps,
    ResourcesDownloadsPanelBlock as Value,
} from "@reactivated";

import { Clickable } from "../Clickables";
import { DocumentList } from "../ProductDetails/DocumentList";

import styles from "./DownloadsPanel.module.scss";

interface Props {
    value: Value;
    documents: ProductDocumentProps[];
    downloadsUrl: string;
}

export const DownloadsPanel = ({ value, documents, downloadsUrl }: Props) => {
    const sidebarGroups = value.sidebar_groups ?? [];
    const documentsEmpty = documents.length === 0;
    const sidebarEmpty = sidebarGroups.length === 0;

    if (documentsEmpty && sidebarEmpty) return <></>;

    return (
        <div className={styles.panel}>
            {!documentsEmpty && (
                <div
                    className={
                        sidebarEmpty ? styles.documentsFull : styles.documents
                    }
                >
                    <DocumentList
                        value={documents}
                        downloadsUrl={downloadsUrl}
                    />
                </div>
            )}
            {!sidebarEmpty && (
                <aside
                    className={
                        documentsEmpty ? styles.sidebarFull : styles.sidebar
                    }
                >
                    {sidebarGroups.map((group, groupIndex) => (
                        <div key={groupIndex} className={styles.sidebarGroup}>
                            <h3 className={styles.sidebarHeading}>
                                {group.heading}
                            </h3>
                            <ul className={styles.sidebarItems}>
                                {group.items?.map((item) => (
                                    <li
                                        key={item.id}
                                        className={styles.sidebarItem}
                                    >
                                        <span>{item.value.description}</span>
                                        {item.value.link?.url && (
                                            <Clickable
                                                simpleLink={item.value.link}
                                                className={
                                                    styles.sidebarItemLink
                                                }
                                            >
                                                {item.value.link.display_name}
                                            </Clickable>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </aside>
            )}
        </div>
    );
};
